export default __webpack_public_path__ + "static/media/f11.f2ea1cc4.jpg";